<div class="row m-0" style="overflow: hidden;">
    <div class="col-6">
        <div class="row mt-5">
            <div class="col-2"></div>
            <div class="col">
                <img src="../../assets/img/outlive-chat.svg" width="150">
                <div style="margin-top: 8rem;">
                    <div class="header-content">
                        Authentication App Code
                    </div>
                    <div class="mt-2 font-13" style="color: #3F3C3C;">Enter the 6 digit code on your device now</div>
                    <div class="mt-4 card border-0 d-flex justify-content-around flex-row" id="authenticateForm">
                        <ng-container *ngFor="let otp of otpList;let i=index; trackBy: trackByFn">
                            <mat-form-field appearance="outline" class=" w60 full-border">
                                <input matInput [(ngModel)]="otpList[i]" id="otp{{i}}" maxlength="1" minlength="1" (keyup)="onKeyUp($event, i)">
                            </mat-form-field>
                        </ng-container>
                    </div>
                    <hr style="border-top: 2px solid #3D8494;">
                    <button class="btn w-100 mt-5 primary-bg text-white" style="height: 55px;border-radius: 7px;" [disabled]="checkDisable()" (click)="authenticateUser()"><b>Submit</b></button>
                    <div class="text-center primary-txt mt-4 cursor" (click)="serviceManager.goBack()">Back</div>
                </div>
            </div>
            <div class="col-2"></div>
        </div>
    </div>
    <div class="col-6 p-0">
        <img class="halfweb-image" src="../../assets/img/signup_bg2.jpg">
    </div>
</div>